import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeliveriesStatisticsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date'];
  endDate: Types.Scalars['Date'];
  courierIds: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
  skip: Types.Scalars['Int'];
  take: Types.Scalars['Int'];
}>;


export type DeliveriesStatisticsQuery = { __typename?: 'Query', DeliveriesStatistics?: { __typename?: 'DeliveriesStatisticsCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'DeliveryStatistics', courierId?: number | null, date?: any | null, noOfDeliveriesPastEta?: number | null, noOfDeliveriesOutOfOrder?: number | null, dailyProgress?: { __typename?: 'DailyProgress', totalDeliveries: number, finishedDeliveries: number, cancelledDeliveries: number, r30Retours: number } | null } | null> | null } | null };


export const DeliveriesStatisticsDocument = gql`
    query DeliveriesStatistics($startDate: Date!, $endDate: Date!, $courierIds: [Int!]!, $skip: Int!, $take: Int!) {
  DeliveriesStatistics(
    startDate: $startDate
    endDate: $endDate
    courierIds: $courierIds
    skip: $skip
    take: $take
  ) {
    items {
      courierId
      date
      noOfDeliveriesPastEta
      noOfDeliveriesOutOfOrder
      dailyProgress {
        totalDeliveries
        finishedDeliveries
        cancelledDeliveries
        r30Retours
      }
    }
    totalCount
  }
}
    `;

/**
 * __useDeliveriesStatisticsQuery__
 *
 * To run a query within a React component, call `useDeliveriesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesStatisticsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      courierIds: // value for 'courierIds'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useDeliveriesStatisticsQuery(baseOptions: Apollo.QueryHookOptions<DeliveriesStatisticsQuery, DeliveriesStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveriesStatisticsQuery, DeliveriesStatisticsQueryVariables>(DeliveriesStatisticsDocument, options);
      }
export function useDeliveriesStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveriesStatisticsQuery, DeliveriesStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveriesStatisticsQuery, DeliveriesStatisticsQueryVariables>(DeliveriesStatisticsDocument, options);
        }
export type DeliveriesStatisticsQueryHookResult = ReturnType<typeof useDeliveriesStatisticsQuery>;
export type DeliveriesStatisticsLazyQueryHookResult = ReturnType<typeof useDeliveriesStatisticsLazyQuery>;
export type DeliveriesStatisticsQueryResult = Apollo.QueryResult<DeliveriesStatisticsQuery, DeliveriesStatisticsQueryVariables>;